import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, firebase_create_new_device, logout } from "./firebase";

import { useMediaQuery } from 'react-responsive';

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import Alert from '@mui/material/Alert';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { Form, Field } from 'react-final-form';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ImageList from '@mui/material/ImageList';
import ImageListItem, { imageListItemClasses } from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Icon } from "@material-ui/core";

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { createTheme, ThemeProvider } from "@mui/material/styles";

import UserInfo from './UserInfo';
import Client from './Client';
import DeviceStatus from "./DeviceStatus";

import moment from "moment-timezone";

//import useWindowScroll from "@react-hook/window-scroll";

import { useSpring, animated } from 'react-spring'


import Styles from './Styles';

import {styled} from "@mui/system";


function AllDevices(props) {
  //const [user, loading_user, error] = useAuthState(auth);
  const uid = sessionStorage.getItem("uid");

  const history = useHistory();

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  const [devices, setDevices] = useState([]);
  const [deviceNumber, setDeviceNumber] = useState(0);
  const [cylinderDeviceNumber, setCylinderDeviceNumber] = useState(0);
  const [tankDeviceNumber, setTankDeviceNumber] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState();
  const [selectedDeviceName, setSelectedDeviceName] = useState("");

  const [isPowerUser, setIsPowerUser] = useState(false);

  const [openAdd, setOpenAdd] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [showDeviceSnackBar, setShowDeviceSnackBar] = useState(false);
  const [deviceMessage, setdeviceMessage] = useState();
  const [newDeviceId, setNewDeviceId] = useState();

  const [createNewDevice, setCreateNewDevice] = useState(false);

  const r = '/devices/';

  const [devices_snapshot, loading_devices, error_db] = useList(db.ref(r));

  const [filteredDevices, setFilteredDevices] = useState();
  const [deviceName, setDeviceName] = useState("");



  const [currentTabIndex, setCurrentTabIndex] = useState(0);


  /*
  const [flip, set] = useState(false)
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: true,
    reverse: flip,
    delay: 200,
    onRest: () => set(!flip),
  }) */

  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  useEffect(() => {
    setIsPowerUser(sessionStorage.getItem("power_user") == "true");
    if(devices_snapshot && !loading_devices)
    {
      const dv = [];
      devices_snapshot.map(device => {
        //console.log(device.key + " :: " + device.val());
        if(device.hasChild("title"))
        {
          if(selectedDeviceName.length > 0)
          {
            if(device.val().title.toLowerCase().includes(selectedDeviceName.toLowerCase()))
            {
              dv.push({
                id: device.key,
                info: device.val(),
              });
            }
          }
          else
          {
            //&& ()
            dv.push({
              id: device.key,
              info: device.val(),
            });
          }
        }
      });
      setDevices(dv);
      setDeviceNumber(dv.length);
      setCylinderDeviceNumber(dv.filter((device) => {
        return 'type' in device.info && device.info.type === 'cylinder';
      }).length);
      setTankDeviceNumber(dv.filter((device) => {
        return 'type' in device.info && device.info.type === 'tank';
      }).length)
    }
  }, [devices_snapshot, loading_devices, selectedDeviceName]);

  if (loading_devices)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading all LPG devices...
              </Typography>
            </Box>
            </div>);
  }

const updateDevice = (deviceId) => {
    history.push(
        { pathname: '/update_device',
          state: {
              deviceId: deviceId,
          }
        });
}

const showDevice = (deviceId, uid) => {
  history.push(
      { pathname: '/device',
        state: {
            deviceId: deviceId,
            uid: uid,
        }
      });
}

const deleteDevice = () => {
  //console.log("Post start datetime:: " + moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"));
  //console.log("Post end datetime:: " + moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"));
}

const handleDelete = (id, name) => {
    setSelectedDevice(id);
    setSelectedDeviceName(name);
    setOpenDelete(true);
}

const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

const handleCloseAdd = () => {
    setOpenAdd(false);
  };

const handleCloseDelete = () => {
    setOpenDelete(false);
  };

const handleClose = () => {
  setShowDeviceSnackBar(false);
}

const handleChangeDeviceName = (event) => {
  //alert(event.target.value)
  setSelectedDeviceName(event.target.value)
};

const handleClearDeviceName = (event) => {
  //alert(event.target.value)
  setSelectedDeviceName("");
};

const handleTabChange = (e, tabIndex) => {
  //console.log(tabIndex);
  setCurrentTabIndex(tabIndex);
};



const action = (
    <React.Fragment>
      <Button color="secondary" size="small" onClick={e => showDevice(newDeviceId, uid)}>
        View
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

const onSubmit = async values => {
   //console.log(values)
   setOpenAdd(false);
   const res = await firebase_create_new_device(values);
   const nd = JSON.parse(res);
   if(nd.status)
   {
      setdeviceMessage(nd.message)
      setShowDeviceSnackBar(true);
      setNewDeviceId(nd.id);
   }
   //console.log(res);
   /*if(res)
   {
    setCreateNewDevice(true);
    setTimeout(() => {
      setCreateNewDevice(false)
    }, 4000);
   }*/
  }

  const Error = ({ name }) => (
    <Field
      name={name}
      subscription={{ touched: true, error: true }}
      render={({ meta: { touched, error } }) =>
        touched && error ? <span>{error}</span> : null
      }
    />
  )

  const required = value => (value ? undefined : 'Required')

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1600,
        xl: 1536
      }
    }
  });

  return (
    <div className="container">  
          {
            isPowerUser ? (
              <>
              <Container maxWidth="xl">
                <Tabs value={currentTabIndex} onChange={handleTabChange}>
                  <Tab label="Status" />
                  <Tab label="Management" />
                </Tabs>
                
                <Grid container spacing={1} >
                  <Grid item xs={12}>
                    <Card sx={{width:"100%"}}>
                    <CardContent>
                          {createNewDevice && (<Alert severity="success">This is a success alert — check it out!</Alert>)}
                            <Stack direction="column">
                              <Typography variant="h6" component="div">
                              All LPG Devices (Power User ONLY)
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                              All {deviceNumber} devices list from Smart LPG Database.
                              </Typography>
                              <Typography variant="body2">
                              All devices in the system, both activated and not-yet-activated, is listing here. Each device can be viewed, edited, or deleted depend on authorization level.
                              </Typography>
                              <Button sx={{mt: 2, mb:1, width: 240}} size="small" variant="contained" onClick={handleClickOpenAdd}>Add New LPG Device</Button>
                              <FormControl sx={{ mt: 2, mb: 2, minWidth: '50%' }} variant="standard">
                                        <InputLabel htmlFor="outlined-adornment-password">Search Device Name</InputLabel>
                                        <Input
                                            id="outlined-adornment-password"
                                            type='text'
                                            value={selectedDeviceName}
                                            onChange={handleChangeDeviceName}
                                            startAdornment={
                                            <InputAdornment position="start">
                                                <IconButton
                                                aria-label="search device name"
                                                //onClick={handleChangeDeviceName}
                                                //onMouseDown={handleChangeDeviceName}
                                                edge="end"
                                                >
                                                <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                            }
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    { selectedDeviceName ?
                                                    (<IconButton
                                                    aria-label="search device name"
                                                    onClick={handleClearDeviceName}
                                                    //onMouseDown={handleChangeDeviceName}
                                                    edge="end"
                                                    >
                                                    <ClearIcon />
                                                    </IconButton>) : (<div/>)
                                                    }
                                                </InputAdornment>
                                            }
                                        />
                                </FormControl>
                              {currentTabIndex === 0 && (
                                <>
                              <Divider><Chip label={cylinderDeviceNumber + " Cylinder Devices"}/></Divider>
                              <ThemeProvider theme={theme}>
                                  <Box
                                    sx={{
                                      pt: 5,
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: "100%",
                                      display: "grid",
                                      gridTemplateColumns: {
                                        xs: "repeat(1, 1fr)",
                                        sm: "repeat(2, 1fr)",
                                        md: "repeat(4, 1fr)",
                                        lg: "repeat(5, 1fr)",
                                        xl: "repeate(7, 1fr)"
                                      },
                                      [`& .${imageListItemClasses.root}`]: {
                                        display: "flex",
                                        flexDirection: "column"
                                      }
                                    }}
                                  >                                         
                                        { 
                                          devices.map((device) => {
                                            return 'type' in device.info && device.info.type === 'cylinder' ?
                                            (
                                            <ImageListItem key={device.id}>
                                              {/*{getLPGTang(device)}
                                              <ImageListItemBar
                                                title={<Button onClick={e => showDevice(device.id)}>{device.title}</Button>}
                                                subtitle={<div>&nbsp;&nbsp;&nbsp;by: {device.client.title}</div>}
                                                position="below"
                                          /> */}
                                              <DeviceStatus deviceId={device.id} clientId={device.info.client.id} showTitle={true} scale={isTabletOrMobile ? 0.6 : 1}/>
                                            </ImageListItem>
                                            ) : (<></>)
                                          }
                                          )
                                        }
                                        </Box>
                              </ThemeProvider>
                              <Divider><Chip label={tankDeviceNumber + " Tank Devices"}/></Divider>
                              <ThemeProvider theme={theme}>
                                  <Box
                                    sx={{
                                      pt: 5,
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: "100%",
                                      display: "grid",
                                      gridTemplateColumns: {
                                        xs: "repeat(1, 1fr)",
                                        sm: "repeat(2, 1fr)",
                                        md: "repeat(4, 1fr)",
                                        lg: "repeat(6, 1fr)",
                                        xl: "repeate(7, 1fr)"
                                      },
                                      [`& .${imageListItemClasses.root}`]: {
                                        display: "flex",
                                        flexDirection: "column"
                                      }
                                    }}
                                  >                                         
                                        { 
                                          devices.map((device) => {
                                            return 'type' in device.info && device.info.type === 'tank' ?
                                            (
                                            <ImageListItem key={device.id} >
                                              {/*{getLPGTang(device)}
                                              <ImageListItemBar
                                                title={<Button onClick={e => showDevice(device.id)}>{device.title}</Button>}
                                                subtitle={<div>&nbsp;&nbsp;&nbsp;by: {device.client.title}</div>}
                                                position="below"
                                          /> */}
                                              <DeviceStatus deviceId={device.id} clientId={device.info.client.id} showTitle={true} scale={isTabletOrMobile ? 0.6 : 1}/>
                                            </ImageListItem>
                                            ) : (<></>)
                                          }
                                          )
                                        }
                                        </Box>
                              </ThemeProvider>
                              </>
                              )}

                              {currentTabIndex === 1 && (
                                <Stack direction="column">
                                <TableContainer >
                                  <Divider><Chip label={cylinderDeviceNumber + " Cylinder Devices"}/></Divider>
                                            <Table sx={{ minWidth: 600}} aria-label="simple table">
                                                <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Device Title</TableCell>
                                                    <TableCell align="center">Device ID</TableCell>
                                                    <TableCell align="center">Owner</TableCell>
                                                    <TableCell align="center">Installation Date</TableCell>
                                                    <TableCell align="center">Due Date</TableCell>
                                                    <TableCell align="center">Payment Date</TableCell>
                                                </TableRow>                                                
                                                </TableHead>
                                                <TableBody>
                                                  {
                                                devices.map((device) => {
                                                  console.log(device)
                                                      return 'type' in device.info && device.info.type === 'cylinder' ?
                                                      (
                                                      <TableRow>
                                                        <TableCell align="center">{device.info.title}</TableCell>
                                                        <TableCell align="center">{device.id}</TableCell>
                                                        <TableCell align="center">{device.info.client.title}</TableCell>
                                                        <TableCell align="center">{moment(device.info.management.installation_date).format("MMMM DD, YYYY")}</TableCell>
                                                        <TableCell align="center">{moment(device.info.management.due_date).format("MMMM DD, YYYY")}</TableCell>
                                                        <TableCell align="center">{moment(device.info.management.payment_date).format("MMMM DD, YYYY")}</TableCell>
                                                      </TableRow>
                                                      ) : (<></>)
                                                    }
                                                    )}
                                                </TableBody>
                                            </Table>
                                      </TableContainer>
                                      <Grid container spacing={2} sx={{pt: 5}}></Grid>
                                      <TableContainer >
                                      <Divider><Chip label={tankDeviceNumber + " Tank Devices"}/></Divider>
                                                <Table sx={{ minWidth: 600 }} aria-label="simple table">
                                                    <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center">Device Title</TableCell>
                                                        <TableCell align="center">Device ID</TableCell>
                                                        <TableCell align="center">Owner</TableCell>
                                                        <TableCell align="center">Installation Date</TableCell>
                                                        <TableCell align="center">Due Date</TableCell>
                                                        <TableCell align="center">Payment Date</TableCell>
                                                    </TableRow>                                                
                                                    </TableHead>
                                                    <TableBody>
                                                      {
                                                    devices.map((device) => {
                                                      console.log(device)
                                                          return 'type' in device.info && device.info.type === 'tank' ?
                                                          (
                                                          <TableRow>
                                                            <TableCell align="center">{device.info.title}</TableCell>
                                                            <TableCell align="center">{device.id}</TableCell>
                                                            <TableCell align="center">{device.info.client.title}</TableCell>
                                                            <TableCell align="center">{moment(device.info.management.installation_date).format("MMMM DD, YYYY")}</TableCell>
                                                            <TableCell align="center">{moment(device.info.management.due_date).format("MMMM DD, YYYY")}</TableCell>
                                                            <TableCell align="center">{moment(device.info.management.payment_date).format("MMMM DD, YYYY")}</TableCell>
                                                          </TableRow>
                                                          ) : (<></>)
                                                        }
                                                        )}
                                                    </TableBody>
                                                </Table>
                                          </TableContainer>
                                          </Stack>
                              )}
                            </Stack>

                        <Dialog open={openAdd} onClose={handleCloseAdd} maxWidth={"lg"} fullWidth={true}>
                        <DialogTitle>Add New LPG Device</DialogTitle>
                        <DialogContent>
                        <DialogContentText>
                            Add new device to the system. This will show up in the device list. Device is needed to be assigned to one of the client (aka store owner). It can be shared later by the owner to any client in the system.  
                        </DialogContentText>
                            <Styles>
                            <Form
                                onSubmit={onSubmit}
                                initialValues={{"client" : {
                                  "id" : "????",
                                  "line_api_key" : "????",
                                  "title" : "????",
                                  "username" : "????"
                                },
                                "sensor_info" : {
                                  "gas_leak" : {
                                    "g1" : {
                                      "desc" : "Gas Leak Detection",
                                      "hardware_status" : "not_installed",
                                      "max_value" : "1.4",
                                      "title" : "Gas Leak"
                                    }
                                  },
                                  "pressure" : {
                                    "p1" : {
                                      "desc" : "Pressure sensor",
                                      "hardware_status" : "not_installed",
                                      "max_rate" : "20",
                                      "max_value" : "150",
                                      "min_value" : "0", 
                                      "title" : "Run A"
                                    },
                                    "p2" : {
                                      "desc" : "Pressure sensor",
                                      "hardware_status" : "not_installed",
                                      "max_rate" : "20",
                                      "max_value" : "150",
                                      "min_value": "0",
                                      "title" : "Run B"
                                    },
                                    "p3" : {
                                      "desc" : "Pressure sensor",
                                      "hardware_status" : "not_installed",
                                      "max_rate" : "20",
                                      "max_value" : "150",
                                      "min_value" : "0",
                                      "title" : "Run C"
                                    }
                                  },
                                  "relay" : {
                                    "r1" : {
                                      "desc" : "Heater sensor",
                                      "hardware_status" : "not_installed",
                                      "title" : "Heater"
                                    },
                                    "r2" : {
                                      "desc" : "Heater sensor",
                                      "hardware_status" : "not_installed",
                                      "title" : "Heater"
                                    }
                                  },
                                  "temperature" : {
                                    "t1" : {
                                      "desc" : "Temperature sensor",
                                      "hardware_status" : "not_installed",
                                      "max_value" : "50",
                                      "title" : "Temperature"
                                    }
                                  },
                                  "level": {
                                    "desc": "Level sensor",
                                    "hardware_status": "not_installed",
                                    "full_level": "85",
                                    "full_tank": "4300",
                                    "min_level": "10",
                                    "warning_threshold": "40",
                                    "title": "Level"
                                  },
                                  "vaporizer": {
                                    "desc": "Vaporizer description",
                                    "hardware_status": "not_installed",
                                    "title": "Vaporizer"
                                  }
                                },
                                "current_status" : {
                                  "date" : moment().tz('Asia/Bangkok').format("YYYYMMDD"),
                                  "time" : moment().tz('Asia/Bangkok').format("HHmmss"),
                                  "timestamp" : moment().tz('Asia/Bangkok').format("YYYYMMDD")+"-"+moment().tz('Asia/Bangkok').format("HHmmss"),
                                  "events" : {
                                    "gas_leak" : "false",
                                    "gas_leak_count": "0",
                                    "pressure1_over" : "false",
                                    "pressure1_too_low": "false",
                                    "pressure2_over" : "false",
                                    "pressure2_too_low":"false",
                                    "pressure3_over" : "false",
                                    "pressure3_too_low": "false",
                                    "pressure_over" : "false",
                                    "temp_over" : "false"
                                  },
                                  "gas_leakage" : "0.0",
                                  "gas_active": "OFF",
                                  "level": {
                                    "status" : "empty",
                                    "trend" : "0"
                                  },
                                  "pressures" : {
                                    "p1" : {
                                      "status" : "n/a",
                                      "value" : "0",
                                      "trend" : "0"
                                    },
                                    "p2" : {
                                      "status" : "n/a",
                                      "value" : "0",
                                      "trend" : "0"
                                    },
                                    "p3" : {
                                      "status" : "n/a",
                                      "value" : "0",
                                      "trend" : "0"
                                    }
                                  },
                                  "relay_status" : "false",
                                  "relays" : {
                                    "r1" : {
                                      "status" : "n/a",
                                      "value" : "false"
                                    },
                                    "r2" : {
                                      "status" : "n/a",
                                      "value" : "false"
                                    }
                                  },
                                  "temps": {
                                    "t1": {
                                      "status": "n/a",
                                      "trend" : "0",
                                    }
                                  },
                                  "vaporizer": {
                                    "fail_state": "false",
                                  },
                                  "temp" : "0.0",
                                  "weight" : "0.0"
                                },
                                "status" : {
                                  "activated" : "false",
                                  "online" : "false"
                                },
                                "management": {
                                  "installation_date": moment().toISOString(),
                                  "due_date": moment().toISOString(),
                                  "payment_date": moment().toISOString(),
                                  "note": "make a note here"
                                },
                                "latitude" : "14.956898537296926",
                                "log_timestamp": moment().valueOf(),
                                "longitude" : "102.04634868770644",
                                "sn": "1234-5678",
                                "type": "cylinder"
                              }}
                                render={({ handleSubmit, form, submitting, pristine, values }) => (
                                    <form onSubmit={handleSubmit}>
                                      <div>
                                          <label>Device Type</label>
                                          <div>
                                            <label>
                                              <Field
                                                name="type"
                                                component="input"
                                                type="radio"
                                                value="tank"
                                              />{' '}
                                              LPG Tank
                                            </label>
                                            <label>
                                              <Field
                                                name="type"
                                                component="input"
                                                type="radio"
                                                value="cylinder"
                                              />{' '}
                                              LPG Cylinder
                                            </label>                            
                                          </div>
                                        </div>
                                    <div>
                                        <label>Device Title</label>
                                        <Field
                                        name="title"
                                        component="input"
                                        type="text"
                                        placeholder="Food Land"
                                        validate={required}
                                        />
                                        <Error name="title" />
                                    </div>                    
                                    <div>
                                        <label>Description</label>
                                        <Field
                                        name="desc"
                                        component="input"
                                        type="text"
                                        placeholder="Device description..."
                                        />
                                    </div>  

                                    <div className="buttons">
                                        <button type="submit" disabled={submitting || pristine}>
                                            Create Device
                                        </button>
                                        <button
                                        type="button"
                                        onClick={form.reset}
                                        disabled={submitting || pristine}
                                        >
                                        Reset
                                        </button>
                                        <button
                                        type="button"
                                        onClick={handleCloseAdd}
                                        >
                                        Cancel
                                        </button>
                                    </div>
                                    {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
                                    </form>
                                )}
                                />
                            </Styles>
                        </DialogContent>
                    </Dialog>
                    <Snackbar
                        open={showDeviceSnackBar}
                        //autoHideDuration={6000}
                        //onClose={handleClose}
                        message={deviceMessage}
                        action={action}
                      />
                    </CardContent>                    
                    </Card>
                  </Grid>
                </Grid>
              </Container>
              </>    
            ):(<div/>)
            }
        </div>
  );
}

export default AllDevices;
